(function () {
  var sticky = document.getElementById('fx-sticky-atc');
  if (sticky && 'IntersectionObserver' in window) {
    var anchor = document.querySelector('.product-form__submit');
    if (anchor) {
      var sio = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            sticky.hidden = !passed;
          });
        },
        { threshold: 0 }
      );
      sio.observe(anchor);
    }
  }
})();

(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  if (document.hidden) return;
  var targets = document.querySelectorAll('.title-wrapper, .rich-text__blocks');
  if (!targets.length) return;
  document.documentElement.classList.add('fx-motion');
  var revealAll = function () {
    targets.forEach(function (t) {
      t.classList.add('fx-in');
    });
  };
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fx-in');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px' }
  );
  targets.forEach(function (t, i) {
    t.classList.add('fx-reveal');
    t.style.transitionDelay = (i % 4) * 60 + 'ms';
    io.observe(t);
  });
  setTimeout(revealAll, 2500);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) revealAll();
  });
})();
